var map = {
	"./AboutTakeover.vue": "./src/js/components/AboutTakeover.vue",
	"./CollectionGallery.vue": "./src/js/components/CollectionGallery.vue",
	"./ProductGallery.vue": "./src/js/components/ProductGallery.vue",
	"./SearchBar.vue": "./src/js/components/SearchBar.vue",
	"./SuperImage.vue": "./src/js/components/SuperImage.vue",
	"./ZoomGallery.vue": "./src/js/components/ZoomGallery.vue",
	"./svg/arrow-right.vue": "./src/js/components/svg/arrow-right.vue",
	"./svg/icon-x.vue": "./src/js/components/svg/icon-x.vue",
	"./svg/magnifier.vue": "./src/js/components/svg/magnifier.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/js/components sync recursive ^\\.\\/.*$";